// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606300157/js/" + chunkId + "." + {"44":"01e7cd5f","225":"59e295b4","481":"6f48d38f","486":"5094637b","770":"03582215"}[chunkId] + ".0.8946442642231257.chunk.js";
};